<div class="d-flex justify-content-between align-items-center px-2">
    <!-- <h6>QR Code</h6> -->
    <div>
        <!-- <button class="btn btn-primary py-0 px-2  mr-1">
            <span class="cursor-pointer modal-resize"
            (click)="maximize();" ><i class="fas fa-compress-arrows-alt"></i></span></button>
        <button class="btn btn-danger py-0 px-2" (click)="onCloseModal()"><i class="fas fa-times"></i></button> -->
       
    </div>


</div>

<qr-code [value]="qrData"  size="250" errorCorrectionLevel="M" > </qr-code>

   <!-- <div  id="my-modal-dialog" class="modal-dialog ">
    <div class="modal-content">
        <form>
            <div class="modal-header">
                <span class="fa fa-window-maximize cursor-pointer modal-resize"
                      (click)="maximize();" *ngIf="!this.isMaximize" title="Maximize"></span>
                <span class="fa fa-window-restore cursor-pointer modal-resize"
                      (click)="restore()" *ngIf="this.isMaximize" title="Restore"></span>
                
            </div>
            <div class="modal-body" id="my-modal-body">
                <qr-code [value]="value"  size="300" errorCorrectionLevel="M" > </qr-code>
            </div>
            <div class="modal-footer">
              
            </div>
        </form>
    </div>
</div> -->
